import CallMadeIcon from '@mui/icons-material/CallMade';

export default CallMadeIcon;
